import { useContext } from 'react';
import { EntryErrorModalContext } from '../../context/EntryErrorModalContext/EntryErrorModalContext';

export const useEntryErrorModalContext = () => {
  const context = useContext(EntryErrorModalContext);

  if (context.isProvided === false) {
    throw new Error(
      'useEntryErrorModalContext must be used within an EntryErrorModalContextProvider'
    );
  }

  return context;
};
